import {Injectable} from '@angular/core';
import {AuthenticationApiService} from './api-implementations/authentication.api.service';
import {serviceFactory} from './config';
import {UsersApiService} from "./api-implementations/users.api.service";
import {ToolsApiService} from './api-implementations/tools.api.service';
import {AclApiService} from './api-implementations/acl.api.service';
import {MediaSourceApiService} from './api-implementations/media-source.api.service';
import {MoviesApiService} from './api-implementations/vision/movies.api.service';
import {MovieGenresApiService} from './api-implementations/vision/movie-genres.api.service';
import {CarouselApiService} from './api-implementations/vision/carousel.api.service';
import {CatalogueApiService} from './api-implementations/vision/catalogue.api.service';


@Injectable({
  providedIn: 'root'
})
export class RestApiService {
  authentication: AuthenticationApiService = serviceFactory(AuthenticationApiService);
  tools: ToolsApiService = serviceFactory(ToolsApiService);
  users: UsersApiService = serviceFactory(UsersApiService);
  acl: AclApiService = serviceFactory(AclApiService);
  mediaSources: MediaSourceApiService = serviceFactory(MediaSourceApiService);
  genres: MovieGenresApiService = serviceFactory(MovieGenresApiService);
  movies: MoviesApiService = serviceFactory(MoviesApiService);
  carousel: CarouselApiService = serviceFactory(CarouselApiService);
  catalogue: CatalogueApiService = serviceFactory(CatalogueApiService);
}

